import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/montessori-toys")({
  head: () => ({
    meta: [
      { title: "Montessori Lelut | Montessori24" },
      { name: "robots", content: "noindex, follow" },
      { property: "og:url", content: "https://montessori24.fi/montessori-lelut" },
    ],
    links: [
      { rel: "canonical", href: "https://montessori24.fi/montessori-lelut" },
    ],
  }),
  component: () => <Navigate to="/montessori-lelut" replace />,
});
